<!-- Mobile: single icon button -->
<button
  type="button"
  class="md:hidden flex items-center justify-center w-9 h-9 rounded-lg border border-border text-content-secondary hover:text-content hover:border-border-strong hover:bg-surface-raised transition-all duration-150 cursor-pointer focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary"
  [attr.aria-label]="isDark() ? 'Switch to light mode' : 'Switch to dark mode'"
  (click)="toggleDarkMode()"
>
  @if (isDark()) {
  <lib-icon icon="sun" class="block w-5 h-5" />
  } @else {
  <lib-icon icon="moon" class="block w-5 h-5" />
  }
</button>

<!-- Desktop: two-icon toggle switch -->
<div class="theme-switch hidden md:flex">
  <input type="checkbox" id="theme-checkbox" [checked]="isDark()" (change)="toggleDarkModeEvent($event)" />
  <label for="theme-checkbox">
    <div></div>
    <lib-icon icon="moon" class="block w-5 h-5" />
    <lib-icon icon="sun" class="block w-5 h-5 text-content" />
  </label>
</div>
